import styled from 'styled-components';

export const Container = styled.div`
  padding: 16px 16px 0 16px;
  margin: 0;
`;

export const Content = styled.div`
  padding: 16px;
  border-radius: 4px;
  background: #fff;

  form{
    margin-bottom: 16px;
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: flex-end;
  margin-bottom: 16px;

  form{
    width: 100%;
    display: flex;
    align-items: flex-end;
  }
`;

export const WrapperSelect = styled.div`
  display: flex;
  flex-direction: column;
  width: calc(100% - 290px);
  margin-right: 8px;
  z-index: 99;

  label{
    margin-bottom: 2px;
    color: var(--color-secondary)
  }
`;

export const WrapperDate = styled.div`
  display: flex;
  flex-direction: column;
  width: 240px;
  margin-right: 8px;
  z-index: 99;
  > div{
    height: 40px;
  }
  label{
    margin-bottom: 2px;
    color: var(--color-secondary)
  }
`;
